// extracted by mini-css-extract-plugin
export default {"goBack":"go-back_goBack__dLM1x","goBackTxt":"go-back_goBackTxt__97qS8"};